// dashboard components
const Leads = () => import(/* webpackChunkName: "leads" */ 'Features/leads/Main');

const leadsRoute =  {
  name: 'leads',
  path: 'leads',
  component: Leads,
  meta: {
    requiresAuth: true,
    title: 'message.leadMessages.leads',
    breadcrumb: 'message.leadMessages.leads'
  }
}

export const LeadsRoute = leadsRoute;